import { registerProcess } from '../../systems/registry.js';
import { PathfinderProcess } from './process.js';

export function registerPathfinderProcess() {
  registerProcess('pathfinder', (id: string) => new PathfinderProcess(id));
}

// Auto-register when imported
registerPathfinderProcess();

